import { useTranslation } from 'react-i18next';
import {
    TIME_RANGE_WEEK,
    TIME_RANGE_TWO_WEEKS,
    TIME_RANGE_MONTH,
    TIME_RANGE_THREE_MONTHS,
    TIME_RANGE_SIX_MONTHS,
    TIME_RANGE_YEAR,
} from '@api/services/constants';
import { DateOptionsInterface } from '@api/components/Suppressions/Unsubscribed/UnsubscribedInterface';
import { DateDropdownOptions } from '@api/store/suppressions/types';

export const useDateFilterData = (): DateOptionsInterface[] => {
    const { t } = useTranslation();

    return [
        { label: t('specifictimerange'), value: DateDropdownOptions.Calendar },
        { label: t('last7days'), value: TIME_RANGE_WEEK },
        { label: t('last14days'), value: TIME_RANGE_TWO_WEEKS },
        { label: t('last30days'), value: TIME_RANGE_MONTH },
        { label: t('last3months'), value: TIME_RANGE_THREE_MONTHS },
        { label: t('last6months'), value: TIME_RANGE_SIX_MONTHS },
        { label: t('lastyear'), value: TIME_RANGE_YEAR },
        { label: t('all'), value: DateDropdownOptions.All },
    ];
};
